module.exports = "<p>\n  role-filter works!\n</p>\n"